// extracted by mini-css-extract-plugin
export default {"wrapper":"v9-z"};